import React from 'react';
import Markdown from "react-markdown";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.js';

function HalfImageHalfText({ data }) {
    return (
        <div key={data.documentId} className="half-image-half-text">
            <div className="views-row views-row-2 views-row-even">

                <article id="node-3" className="node node-half-image-half-text-band node-promoted node-teaser clearfix"
                         about="/node/3" typeof="sioc:Item foaf:Document">

                    <div className="row half-half-div background-full-width clearfix scrollme  light-gray-background"
                         id="WhyAirQualityMattersBand">
                        <div className={'half-wrapper clearfix '.concat(data.backgroundColorHalf != null ? data.backgroundColorHalf : '')}>

                            <div className="col-sm-6 col-xs-12 no-padding half img-half parallax-window"
                                 data-z-index="1" data-speed="0.6" data-over-scroll-fix="true" data-position="left"
                                 data-natural-width="650" data-natural-height="750" data-parallax="scroll"
                                 data-image-src={data.image.url}
                                 style={{backgroundImage: 'url('.concat({data: data.image.url}).concat(')'), float: data.imageOnLeftSide ? 'left' : 'right'}}>
                                <img alt="Bridge" className="cover-div hidden"
                                     src={data.image.url}/>
                            </div>

                            {/*MOBILE IMAGE BLOCK; CSS SETTINGS HAVE THIS HIDDEN ON LARGER SCREENS AND VICE VERSA*/}
                            <div className="col-sm-6 col-xs-12 no-padding half img-half no-parallax">
                                <img alt="Bridge" className="cover-div" src={data.image.url}/>
                            </div>

                            <div className="col-sm-6 col-xs-12 half text-half" style={{height: '100%'}}>
                                <div className="col-sm-12 scroll-text max-width-half right-half animateme transform-half-text"
                                     data-when="enter" data-from="0" data-to="1" data-opacity="1" data-translatey="85"
                                     data-easing="easeinout"
                                     style={{opacity: '1'}}>
                                    <p className={"section-headline ".concat(data.backgroundColorHalf === 'blue-gradient' ? 'white-text' : 'light-blue-text')}>
                                        {data.titleText} </p>
                                    <div className={"body-text ".concat(data.backgroundColorHalf  === 'blue-gradient' ? 'white-text' : '').concat(data.backgroundColorHalf === 'blue-gradient' ? '' : ' light-blue-headline')}>
                                        <p>
                                            <Markdown>{data.paragraphText.replaceAll('\n','  \n')}</Markdown>
                                        </p>
                                        {(data.title.toLowerCase().includes('about')
                                            && data.title.toLowerCase().includes('history')
                                            && data.title.toLowerCase().includes('team')) ?
                                            <div className="half-text-button green-background">
                                                <a className="white-text sponsors-button"
                                                   href="/leadership">MEET OUR LEADERSHIP TEAM
                                                </a>
                                            </div>
                                            : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </article>
            </div>
        </div>
    );
}

export default HalfImageHalfText;
